import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { hashSettled } from 'rsvp';

import type { Service } from 'webapp-types';

export default class MetricsRoute extends Route {
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): Promise<unknown> {
		const promises = [
			this.navigationService.initialRequestsPromise,
			this.mmMetricsService.requestMetrics(),
		];

		return hashSettled(promises);
	}

	override afterModel(): void {
		void this.mmMetricsService.prepareForMetricEditing();
	}
}
